module.exports = __webpack_public_path__ + "img/BN.009a3bdd.svg";